import type { RatingSummary } from '../types'

export interface StarRow {
  star: number
  count: number
  /** 0–100, share of all ratings. */
  percent: number
}

/** Five rows, 5★ first, with the share each takes of the total. */
export function starRows(summary: Pick<RatingSummary, 'distribution' | 'count'>): StarRow[] {
  const total = summary.count
  return [5, 4, 3, 2, 1].map((star) => {
    const count = summary.distribution[String(star)] ?? 0
    return { star, count, percent: total > 0 ? Math.round((count / total) * 100) : 0 }
  })
}

/** The empty-state copy (brief AD9): never show a misleading average on a handful of ratings. */
export function insufficientMessage(summary: Pick<RatingSummary, 'count' | 'min_count'>): string {
  if (summary.count === 0) return 'No ratings yet.'
  const remaining = summary.min_count - summary.count
  return `Not enough ratings yet (${summary.count} of ${summary.min_count}). ${remaining} more needed for an average.`
}

export function formatAverage(average: number | null): string {
  return average == null ? '—' : average.toFixed(1)
}

export const RATING_WORD: Record<number, string> = {
  1: 'Poor',
  2: 'Fair',
  3: 'Average',
  4: 'Good',
  5: 'Excellent',
}
